import { h } from '@logicflow/core';
import { RectResize } from '@logicflow/extension/es/NodeResize';
import { renderRotatedText } from './textUtils';
import { getThemeStyle } from '../theme';

const { view: RectResizeView, model: RectResizeModel } = RectResize;

/**
 * Lane — Horizontal subdivision inside a Pool (Participant).
 *
 * Lanes are NOT independent entities — they are managed as subdivisions
 * of a Participant. They span the full pool width (minus the pool header)
 * and stack vertically. They cannot be dragged independently.
 *
 * Visual: simple horizontal band separated by border lines, with
 * a rotated name label in the left margin area.
 */

const LANE_LABEL_WIDTH = 25;

class LaneView extends RectResizeView {
  getResizeShape() {
    const { model } = this.props;
    const { x, y, width, height } = model;
    const style = model.getNodeStyle();

    const left = x - width / 2;
    const top = y - height / 2;

    return h('g', {}, [
      // Lane body — horizontal band within the pool
      h('rect', {
        x: left,
        y: top,
        width,
        height,
        rx: 0,
        ry: 0,
        ...style,
        fill: 'none',
        pointerEvents: 'none',
      }),
      // Rotated name text in the left margin
      renderRotatedText(h, (model.properties && model.properties.name) || '', left + LANE_LABEL_WIDTH / 2, y, height - 10, { fontSize: 11, graphModel: model.graphModel }),
    ]);
  }
}

class LaneModel extends RectResizeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = data.width || data.properties?.width || 570;
    this.height = data.height || data.properties?.height || 125;
    this.radius = 0;
    this.minWidth = 150;
    this.minHeight = 40;
    this.maxWidth = 3000;
    this.maxHeight = 1500;
    // Lane text is rendered by the view — clear default text overlay
    this.text = { x: this.x, y: this.y, editable: false, draggable: false, value: '' };
    // Lanes cannot be dragged independently — they are managed by the pool
    this.draggable = false;
    // Sync dimensions into properties
    if (!data.properties?.width) this.setProperties({ width: this.width, height: this.height });
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'lane');
    style.stroke = t.stroke || '#000';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.fill = t.fill || '#fff';
    return style;
  }

  getResizeOutlineStyle() {
    return { stroke: '#1890ff', strokeWidth: 1, strokeDasharray: '3,3' };
  }
}

export const Lane = {
  type: 'epx:Lane',
  view: LaneView,
  model: LaneModel,
};
